import React, { useState } from "react";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const EditNameModal = ({ map, editMap }) => {
  const [name, setName] = useState(map.name);

  const MySwal = withReactContent(swal);

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handeConfirm = () => {
    editMap(map, 'name', name);

    MySwal.close();
  }

  return (
    <div className="points-modal">
      <input
        className="points-modal__points-input input-behavior"
        type="text"
        placeholder="Enter points"
        value={name}
        onChange={handleChangeName}
        autoFocus
      />

      <div className="points-modal__buttons">
      <button
        type='button'
        className='points-modal__button btn-secondary'
        onClick={() => MySwal.close()}
      >
        <span>Cancel</span>
      </button>
      <button
        type='button'
        className='points-modal__button btn-primary'
        onClick={handeConfirm}
        disabled={!name}
      >
        <span>Change</span>
      </button>
      </div>
    </div>
  )
}
